define('responsive-game-feed/app/scripts/views/Error',['require','exports','module','hogan/web/builds/3.0.2/hogan-3.0.2.min.amd','../utils/Utils','gameday-language/gameday-language','gameday-language/translator'],function(require, exports, module) {

    var hogan = require("hogan/web/builds/3.0.2/hogan-3.0.2.min.amd");
    var Utils = require("../utils/Utils");
    var gamedayLanguage = require("gameday-language/gameday-language");
    var translator = require("gameday-language/translator");

    /**
     * CLASS DESCRIPTION
     *
     * @param NAME {TYPE} PARAM DESCRIPTION
     * @return {TYPE} RETURN DESCRIPTION
     */
    function ErrorView(element, template) {
        var errorText = "The game feed will begin shortly";
        var lang = Utils.options.language;
        if (lang === 'es') {
          var decode = translator(lang,true);
          errorText = decode.translate(errorText);
        }
        
        this.element = $("#game-feed");
        this.template = Hogan.compile("<div class='feed-item row error msg'><h3>"+errorText+".</h3></div>");
        this.errdiv;
    }

    ErrorView.prototype = {

        /**
         * METHOD DESCRIPTION
         *
         * @param NAME {TYPE} PARAM DESCRIPTION
         * @return {TYPE} RETURN DESCRIPTION
         */
        render: function() {
            this.element.append(this.template.render());
            this.errdiv = this.element.find(".error");
            return this;

        },

        /**
         * METHOD DESCRIPTION
         *
         * @param NAME {TYPE} PARAM DESCRIPTION
         * @return {TYPE} RETURN DESCRIPTION
         */
        show: function() {
            this.errdiv.show();
            return this;
        },

        /**
         * METHOD DESCRIPTION
         *
         * @param NAME {TYPE} PARAM DESCRIPTION
         * @return {TYPE} RETURN DESCRIPTION
         */
        hide: function() {
            this.errdiv.hide();
            return this;
        },
        
        /**
         * METHOD DESCRIPTION
         *
         * @param NAME {TYPE} PARAM DESCRIPTION
         * @return {TYPE} RETURN DESCRIPTION
         */
        destory: function() {
            this.errdiv.remove();
            return this;
        }

    };


    return ErrorView;

});
